import React from 'react';
import Button from '../../../../../components/Button';
import FileButton from '../../../../../components/FileButton';
import styles from './UploadButton.m.sass';
var UploadButton = function UploadButton(_ref) {
  var onChange = _ref.onChange,
    loading = _ref.loading,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(FileButton, {
    multiple: false,
    onChange: onChange
  }, /*#__PURE__*/React.createElement(Button, {
    className: styles.uploadButton,
    loading: loading,
    disabled: loading
    // iconLeft={<Icon small material name="file upload" />}
  }, children));
};
export default UploadButton;
//# sourceMappingURL=index.js.map
